import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _31526336 = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _118792d0 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _fa84f476 = () => interopDefault(import('../pages/account/scholen/index.vue' /* webpackChunkName: "pages/account/scholen/index" */))
const _480423b2 = () => interopDefault(import('../pages/account/schoolbeheerders/index.vue' /* webpackChunkName: "pages/account/schoolbeheerders/index" */))
const _68d9f1e0 = () => interopDefault(import('../pages/account/schoolgebruikers/index.vue' /* webpackChunkName: "pages/account/schoolgebruikers/index" */))
const _0b9a1262 = () => interopDefault(import('../pages/auth/accept-terms.vue' /* webpackChunkName: "pages/auth/accept-terms" */))
const _7285703e = () => interopDefault(import('../pages/auth/inloggen.vue' /* webpackChunkName: "pages/auth/inloggen" */))
const _7519f4d8 = () => interopDefault(import('../pages/auth/registreren/index.vue' /* webpackChunkName: "pages/auth/registreren/index" */))
const _1f1f642b = () => interopDefault(import('../pages/auth/wachtwoord-vergeten/index.vue' /* webpackChunkName: "pages/auth/wachtwoord-vergeten/index" */))
const _4f476245 = () => interopDefault(import('../pages/account/gebruikersbeheer/create.vue' /* webpackChunkName: "pages/account/gebruikersbeheer/create" */))
const _262335e2 = () => interopDefault(import('../pages/account/scholen/aanmaken.vue' /* webpackChunkName: "pages/account/scholen/aanmaken" */))
const _13503be9 = () => interopDefault(import('../pages/auth/2fa/instellen.vue' /* webpackChunkName: "pages/auth/2fa/instellen" */))
const _07ae73ca = () => interopDefault(import('../pages/auth/registreren/beheerder.vue' /* webpackChunkName: "pages/auth/registreren/beheerder" */))
const _e1e8a114 = () => interopDefault(import('../pages/auth/wachtwoord-instellen/token.vue' /* webpackChunkName: "pages/auth/wachtwoord-instellen/token" */))
const _57b009d2 = () => interopDefault(import('../pages/auth/wachtwoord-vergeten/token.vue' /* webpackChunkName: "pages/auth/wachtwoord-vergeten/token" */))
const _57ef15b8 = () => interopDefault(import('../pages/account/gebruikersbeheer/_uuid/index.vue' /* webpackChunkName: "pages/account/gebruikersbeheer/_uuid/index" */))
const _650c356d = () => interopDefault(import('../pages/account/scholen/_id.vue' /* webpackChunkName: "pages/account/scholen/_id" */))
const _a62ef36e = () => interopDefault(import('../pages/account/gebruikersbeheer/_uuid/logboek.vue' /* webpackChunkName: "pages/account/gebruikersbeheer/_uuid/logboek" */))
const _3eb05c53 = () => interopDefault(import('../pages/document/_uuid/index.vue' /* webpackChunkName: "pages/document/_uuid/index" */))
const _0d335db8 = () => interopDefault(import('../pages/document/_uuid/logboek.vue' /* webpackChunkName: "pages/document/_uuid/logboek" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _31526336,
    pathToRegexpOptions: {"strict":true},
    name: "account___nl"
  }, {
    path: "/en",
    component: _118792d0,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/account/scholen",
    component: _fa84f476,
    pathToRegexpOptions: {"strict":true},
    name: "account-scholen___nl"
  }, {
    path: "/account/schoolbeheerders",
    component: _480423b2,
    pathToRegexpOptions: {"strict":true},
    name: "account-schoolbeheerders___nl"
  }, {
    path: "/account/schoolgebruikers",
    component: _68d9f1e0,
    pathToRegexpOptions: {"strict":true},
    name: "account-schoolgebruikers___nl"
  }, {
    path: "/auth/accept-terms",
    component: _0b9a1262,
    pathToRegexpOptions: {"strict":true},
    name: "auth-accept-terms___nl"
  }, {
    path: "/auth/inloggen",
    component: _7285703e,
    pathToRegexpOptions: {"strict":true},
    name: "auth-inloggen___nl"
  }, {
    path: "/auth/registreren",
    component: _7519f4d8,
    pathToRegexpOptions: {"strict":true},
    name: "auth-registreren___nl"
  }, {
    path: "/auth/wachtwoord-vergeten",
    component: _1f1f642b,
    pathToRegexpOptions: {"strict":true},
    name: "auth-wachtwoord-vergeten___nl"
  }, {
    path: "/en/account",
    component: _31526336,
    pathToRegexpOptions: {"strict":true},
    name: "account___en"
  }, {
    path: "/account/gebruikersbeheer/create",
    component: _4f476245,
    pathToRegexpOptions: {"strict":true},
    name: "account-gebruikersbeheer-create___nl"
  }, {
    path: "/account/scholen/aanmaken",
    component: _262335e2,
    pathToRegexpOptions: {"strict":true},
    name: "account-scholen-aanmaken___nl"
  }, {
    path: "/auth/2fa/instellen",
    component: _13503be9,
    pathToRegexpOptions: {"strict":true},
    name: "auth-2fa-instellen___nl"
  }, {
    path: "/auth/registreren/beheerder",
    component: _07ae73ca,
    pathToRegexpOptions: {"strict":true},
    name: "auth-registreren-beheerder___nl"
  }, {
    path: "/auth/wachtwoord-instellen/token",
    component: _e1e8a114,
    pathToRegexpOptions: {"strict":true},
    name: "auth-wachtwoord-instellen-token___nl"
  }, {
    path: "/auth/wachtwoord-vergeten/token",
    component: _57b009d2,
    pathToRegexpOptions: {"strict":true},
    name: "auth-wachtwoord-vergeten-token___nl"
  }, {
    path: "/en/account/scholen",
    component: _fa84f476,
    pathToRegexpOptions: {"strict":true},
    name: "account-scholen___en"
  }, {
    path: "/en/account/schoolbeheerders",
    component: _480423b2,
    pathToRegexpOptions: {"strict":true},
    name: "account-schoolbeheerders___en"
  }, {
    path: "/en/account/schoolgebruikers",
    component: _68d9f1e0,
    pathToRegexpOptions: {"strict":true},
    name: "account-schoolgebruikers___en"
  }, {
    path: "/en/auth/accept-terms",
    component: _0b9a1262,
    pathToRegexpOptions: {"strict":true},
    name: "auth-accept-terms___en"
  }, {
    path: "/en/auth/inloggen",
    component: _7285703e,
    pathToRegexpOptions: {"strict":true},
    name: "auth-inloggen___en"
  }, {
    path: "/en/auth/registreren",
    component: _7519f4d8,
    pathToRegexpOptions: {"strict":true},
    name: "auth-registreren___en"
  }, {
    path: "/en/auth/wachtwoord-vergeten",
    component: _1f1f642b,
    pathToRegexpOptions: {"strict":true},
    name: "auth-wachtwoord-vergeten___en"
  }, {
    path: "/en/account/gebruikersbeheer/create",
    component: _4f476245,
    pathToRegexpOptions: {"strict":true},
    name: "account-gebruikersbeheer-create___en"
  }, {
    path: "/en/account/scholen/aanmaken",
    component: _262335e2,
    pathToRegexpOptions: {"strict":true},
    name: "account-scholen-aanmaken___en"
  }, {
    path: "/en/auth/2fa/instellen",
    component: _13503be9,
    pathToRegexpOptions: {"strict":true},
    name: "auth-2fa-instellen___en"
  }, {
    path: "/en/auth/registreren/beheerder",
    component: _07ae73ca,
    pathToRegexpOptions: {"strict":true},
    name: "auth-registreren-beheerder___en"
  }, {
    path: "/en/auth/wachtwoord-instellen/token",
    component: _e1e8a114,
    pathToRegexpOptions: {"strict":true},
    name: "auth-wachtwoord-instellen-token___en"
  }, {
    path: "/en/auth/wachtwoord-vergeten/token",
    component: _57b009d2,
    pathToRegexpOptions: {"strict":true},
    name: "auth-wachtwoord-vergeten-token___en"
  }, {
    path: "/en/account/gebruikersbeheer/:uuid",
    component: _57ef15b8,
    pathToRegexpOptions: {"strict":true},
    name: "account-gebruikersbeheer-uuid___en"
  }, {
    path: "/en/account/scholen/:id",
    component: _650c356d,
    pathToRegexpOptions: {"strict":true},
    name: "account-scholen-id___en"
  }, {
    path: "/en/account/gebruikersbeheer/:uuid?/logboek",
    component: _a62ef36e,
    pathToRegexpOptions: {"strict":true},
    name: "account-gebruikersbeheer-uuid-logboek___en"
  }, {
    path: "/account/gebruikersbeheer/:uuid",
    component: _57ef15b8,
    pathToRegexpOptions: {"strict":true},
    name: "account-gebruikersbeheer-uuid___nl"
  }, {
    path: "/account/scholen/:id",
    component: _650c356d,
    pathToRegexpOptions: {"strict":true},
    name: "account-scholen-id___nl"
  }, {
    path: "/en/document/:uuid",
    component: _3eb05c53,
    pathToRegexpOptions: {"strict":true},
    name: "document-uuid___en"
  }, {
    path: "/account/gebruikersbeheer/:uuid?/logboek",
    component: _a62ef36e,
    pathToRegexpOptions: {"strict":true},
    name: "account-gebruikersbeheer-uuid-logboek___nl"
  }, {
    path: "/en/document/:uuid?/logboek",
    component: _0d335db8,
    pathToRegexpOptions: {"strict":true},
    name: "document-uuid-logboek___en"
  }, {
    path: "/document/:uuid",
    component: _3eb05c53,
    pathToRegexpOptions: {"strict":true},
    name: "document-uuid___nl"
  }, {
    path: "/document/:uuid?/logboek",
    component: _0d335db8,
    pathToRegexpOptions: {"strict":true},
    name: "document-uuid-logboek___nl"
  }, {
    path: "/",
    component: _118792d0,
    pathToRegexpOptions: {"strict":true},
    name: "index___nl"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
